// extracted by mini-css-extract-plugin
export default {"inputField":"StrategyDetail_inputField__PyGqw"};